"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var uuid = new Date().getTime();
var getUniqueID = function getUniqueID() {
    uuid++;
    return uuid.toString(16);
};

var generateIdsOnTokens = function generateIdsOnTokens(tokens) {
    if (!tokens || !tokens.length) return tokens;

    return tokens.map(function (token) {
        token.id = getUniqueID();
        token.children = generateIdsOnTokens(token.children);

        return token;
    });
};

exports.default = generateIdsOnTokens;